module.exports = __webpack_public_path__ + "public/1.0.1_009961/img/defaultMenu.870a2959.svg";